 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');

 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				document.head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"template-Default~template-Focus~template-Fullscreen~template-ImageGrid~template-Introduction~templat~6c93e472":"template-Default~template-Focus~template-Fullscreen~template-ImageGrid~template-Introduction~templat~6c93e472","template-Default":"template-Default","template-Focus":"template-Focus","template-Fullscreen":"template-Fullscreen","template-ImageGrid~template-Introduction":"template-ImageGrid~template-Introduction","template-ImageGrid":"template-ImageGrid","template-Introduction":"template-Introduction","template-Steps":"template-Steps","template-Transition":"template-Transition","template-Versus":"template-Versus","visualization-Area~visualization-Boolean~visualization-Bubble~visualization-BubbleArea~visualization~cd78eead":"visualization-Area~visualization-Boolean~visualization-Bubble~visualization-BubbleArea~visualization~cd78eead","visualization-Area":"visualization-Area","visualization-Boolean":"visualization-Boolean","visualization-Bubble":"visualization-Bubble","visualization-BubbleArea~visualization-Map~visualization-SunFlower":"visualization-BubbleArea~visualization-Map~visualization-SunFlower","visualization-BubbleArea~visualization-Map":"visualization-BubbleArea~visualization-Map","visualization-Map":"visualization-Map","visualization-BubbleArea~visualization-SunFlower":"visualization-BubbleArea~visualization-SunFlower","visualization-BubbleArea":"visualization-BubbleArea","visualization-SunFlower":"visualization-SunFlower","visualization-Doughnut":"visualization-Doughnut","visualization-HorizontalBar":"visualization-HorizontalBar","visualization-Line":"visualization-Line","visualization-Pie":"visualization-Pie","visualization-PolarArea":"visualization-PolarArea","visualization-Radar":"visualization-Radar","visualization-Range":"visualization-Range","visualization-Scatter":"visualization-Scatter","visualization-Table":"visualization-Table","visualization-Tracker":"visualization-Tracker","visualization-VerticalBar":"visualization-VerticalBar","visualization-Typed":"visualization-Typed"}[chunkId]||chunkId) + "." + {"chunk-1c2d1e9c":"92178073","chunk-2d0bacba":"a584a22e","chunk-2d0d7296":"567f3cf6","chunk-2d0e5d53":"eb0a707f","chunk-2d22269e":"e1181eef","chunk-2d22d015":"af353c07","chunk-2ea6dc22":"1b7e567f","chunk-5d6dcabc":"c32e6331","template-Default~template-Focus~template-Fullscreen~template-ImageGrid~template-Introduction~templat~6c93e472":"68358d72","template-Default":"2363e9e3","template-Focus":"67dfd972","template-Fullscreen":"4f25d864","template-ImageGrid~template-Introduction":"9e7be42d","template-ImageGrid":"efe6ffe4","template-Introduction":"d00333d8","template-Steps":"cebe7b20","template-Transition":"9aade8fa","template-Versus":"40cda0ca","visualization-Area~visualization-Boolean~visualization-Bubble~visualization-BubbleArea~visualization~cd78eead":"2715f1ca","visualization-Area":"ada17a0b","visualization-Boolean":"f2463e79","visualization-Bubble":"4d4e803c","visualization-BubbleArea~visualization-Map~visualization-SunFlower":"6c67345f","visualization-BubbleArea~visualization-Map":"424803f2","visualization-Map":"2e33c4a4","visualization-BubbleArea~visualization-SunFlower":"be9b1156","visualization-BubbleArea":"79a19f53","visualization-SunFlower":"02debb62","visualization-Doughnut":"1beed134","visualization-HorizontalBar":"a0188735","visualization-Line":"cf0325e9","visualization-Pie":"1bd4eed2","visualization-PolarArea":"c909d767","visualization-Radar":"a2461a23","visualization-Range":"131cf646","visualization-Scatter":"b72ba168","visualization-Table":"8244dc61","visualization-Tracker":"68258cc4","visualization-VerticalBar":"69085f06","visualization-Typed":"cfd34710"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1c2d1e9c":1,"template-ImageGrid~template-Introduction":1,"template-Versus":1,"visualization-Range":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"template-Default~template-Focus~template-Fullscreen~template-ImageGrid~template-Introduction~templat~6c93e472":"template-Default~template-Focus~template-Fullscreen~template-ImageGrid~template-Introduction~templat~6c93e472","template-Default":"template-Default","template-Focus":"template-Focus","template-Fullscreen":"template-Fullscreen","template-ImageGrid~template-Introduction":"template-ImageGrid~template-Introduction","template-ImageGrid":"template-ImageGrid","template-Introduction":"template-Introduction","template-Steps":"template-Steps","template-Transition":"template-Transition","template-Versus":"template-Versus","visualization-Area~visualization-Boolean~visualization-Bubble~visualization-BubbleArea~visualization~cd78eead":"visualization-Area~visualization-Boolean~visualization-Bubble~visualization-BubbleArea~visualization~cd78eead","visualization-Area":"visualization-Area","visualization-Boolean":"visualization-Boolean","visualization-Bubble":"visualization-Bubble","visualization-BubbleArea~visualization-Map~visualization-SunFlower":"visualization-BubbleArea~visualization-Map~visualization-SunFlower","visualization-BubbleArea~visualization-Map":"visualization-BubbleArea~visualization-Map","visualization-Map":"visualization-Map","visualization-BubbleArea~visualization-SunFlower":"visualization-BubbleArea~visualization-SunFlower","visualization-BubbleArea":"visualization-BubbleArea","visualization-SunFlower":"visualization-SunFlower","visualization-Doughnut":"visualization-Doughnut","visualization-HorizontalBar":"visualization-HorizontalBar","visualization-Line":"visualization-Line","visualization-Pie":"visualization-Pie","visualization-PolarArea":"visualization-PolarArea","visualization-Radar":"visualization-Radar","visualization-Range":"visualization-Range","visualization-Scatter":"visualization-Scatter","visualization-Table":"visualization-Table","visualization-Tracker":"visualization-Tracker","visualization-VerticalBar":"visualization-VerticalBar","visualization-Typed":"visualization-Typed"}[chunkId]||chunkId) + "." + {"chunk-1c2d1e9c":"d80cd41b","chunk-2d0bacba":"31d6cfe0","chunk-2d0d7296":"31d6cfe0","chunk-2d0e5d53":"31d6cfe0","chunk-2d22269e":"31d6cfe0","chunk-2d22d015":"31d6cfe0","chunk-2ea6dc22":"31d6cfe0","chunk-5d6dcabc":"31d6cfe0","template-Default~template-Focus~template-Fullscreen~template-ImageGrid~template-Introduction~templat~6c93e472":"31d6cfe0","template-Default":"31d6cfe0","template-Focus":"31d6cfe0","template-Fullscreen":"31d6cfe0","template-ImageGrid~template-Introduction":"9c84ebeb","template-ImageGrid":"31d6cfe0","template-Introduction":"31d6cfe0","template-Steps":"31d6cfe0","template-Transition":"31d6cfe0","template-Versus":"f1b0de28","visualization-Area~visualization-Boolean~visualization-Bubble~visualization-BubbleArea~visualization~cd78eead":"31d6cfe0","visualization-Area":"31d6cfe0","visualization-Boolean":"31d6cfe0","visualization-Bubble":"31d6cfe0","visualization-BubbleArea~visualization-Map~visualization-SunFlower":"31d6cfe0","visualization-BubbleArea~visualization-Map":"31d6cfe0","visualization-Map":"31d6cfe0","visualization-BubbleArea~visualization-SunFlower":"31d6cfe0","visualization-BubbleArea":"31d6cfe0","visualization-SunFlower":"31d6cfe0","visualization-Doughnut":"31d6cfe0","visualization-HorizontalBar":"31d6cfe0","visualization-Line":"31d6cfe0","visualization-Pie":"31d6cfe0","visualization-PolarArea":"31d6cfe0","visualization-Radar":"31d6cfe0","visualization-Range":"05eda759","visualization-Scatter":"31d6cfe0","visualization-Table":"31d6cfe0","visualization-Tracker":"31d6cfe0","visualization-VerticalBar":"31d6cfe0","visualization-Typed":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
